import React, { memo, useState } from "react";
import Editor from "../../../../../components/agent-v3/editor/Editor";
import { WorkflowTriggerType } from "../../../../../__generated__/api";
import { PropertiesByTrigger } from "./useGeneralSettingsProperties";
import Styles from "./GeneralSettings.module.scss";

function GeneralDetailsDescription({ properties }: { properties: PropertiesByTrigger<WorkflowTriggerType> }) {
    const [description, setDescription] = useState(() => properties.description.value);

    return (
        <Editor
            value={description}
            onChange={(html, content) => {
                setDescription(html);
                properties.description.setValue(content);
            }}
            size="medium"
            hasBorder
            placeholder="Enter Action Description"
            canFormat={false}
            rootClassName={Styles["editor-form-control"]}
        />
    );
}

export default memo(GeneralDetailsDescription);
